import { connect } from "react-redux";
import Confirm from "../../components/Segment/Confirm";
import {
  loadAttributes,
  selectSegment,
  setSegmentName,
  saveSegment,
  setPlotValues,
  verifySegmentName,
  clearAllSelectedState,
  clearAllSelectedCity,
  selectState,
  selectCity,
  clearAllZipCode,
  clearZipCode,
} from "../../actions/SegmentCreation";
import { sendAssistRequest } from "../../actions/Insights";
import { tail, isEmpty } from "lodash";

const mapStateToProps = state => {
  const {
    categories,
    selected_segments,
    segment_name,
    plotted_values,
    selected_city,
    selected_county,
    selected_dma,
    selected_state,
    zipcode,
    isNameDuplicated,
    segment_id,
    rules_id,
    audience_total_count,
    save_segment_success,
    save_segment_error_errorNo,
    send_assist_request_error,
    request_assist_successful,
    save_segment_error_message,
    targetHouseholdsOnly,
  } = state.segmentCreation;
  const { active_segment_attributes } = state.segmentList;
  const { userId, selected_client, clients, roleId } = state.app;
  const demographic = categories ? tail(categories) : undefined;
  const geographic = categories ? categories[0] : undefined;
  const selectedClient = isEmpty(clients)
    ? []
    : clients.find(function(item) {
        return parseInt(item.id, 10) === parseInt(selected_client, 10);
      });
  return {
    geoAttributes: geographic,
    demoAttributes: demographic,
    selected_segments,
    userId,
    roleId,
    selected_client,
    selected_client_name: selectedClient ? selectedClient.name : "",
    segment_name,
    plotted_values,
    selected_city,
    selected_state,
    selected_county,
    selected_dma,
    zipcode,
    segment_id,
    isNameDuplicated,
    rules_id,
    audience_total_count,
    active_segment_attributes,
    save_segment_error_errorNo,
    save_segment_error_message,
    save_segment_success,
    send_assist_request_error,
    request_assist_successful,
    targetHouseholdsOnly,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendAssistRequest: data => {
      dispatch(sendAssistRequest(data));
    },
    loadAttributes: cid => {
      dispatch(loadAttributes(cid));
    },
    selectSegment: val => {
      dispatch(selectSegment(val));
    },
    setSegmentName: val => {
      dispatch(setSegmentName(val));
    },
    saveSegment: data => {
      dispatch(saveSegment(data));
    },
    verifySegmentName: (clientId, name, id) => {
      dispatch(verifySegmentName(clientId, name, id));
    },
    setPlotValues: val => {
      dispatch(setPlotValues(val));
    },
    clearAllSelectedState: () => {
      dispatch(clearAllSelectedState());
    },
    clearAllSelectedCity: () => {
      dispatch(clearAllSelectedCity());
    },
    clearAllZipCode: () => {
      dispatch(clearAllZipCode());
    },
    clearZipCode: val => {
      dispatch(clearZipCode(val));
    },
    selectCity: (id, flag) => dispatch(selectCity(id, flag)),
    selectState: (id, flag) => dispatch(selectState(id, flag)),
  };
};

const SegmentConfirm = connect(mapStateToProps, mapDispatchToProps)(Confirm);

export default SegmentConfirm;



// WEBPACK FOOTER //
// ./src/containers/Segment/SegmentConfirm.js